import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { AccessibleRounded, Wifi, Power } from '@mui/icons-material/';
import SimpleCard from '../../../../components/SimpleCard';
import CheckIcon from './CheckIcon';
import { formatDate, formatTime } from '../../../../utils';

export default function AboutYourEvent({
  registeredAttendees,
  vendors,
  foodTrucks,
  event,
  freeFeatures,
  seeDigitalMarketing,
}) {
  const {
    events: { urlData },
  } = useSelector((store) => store);
  if (!event.id) return false;
  const parametersEvent = event.parameters_event;
  const { state, city } = event;

  return (
    <SimpleCard>
      <div>
        <Typography variant="h6" marginTop={0}>
          About your event:
        </Typography>
      </div>

      <Grid container marginY={3}>
        <Grid item xs={12} md={6}>
          <div>
            <Typography>{event.description}</Typography>
            <Typography>{`${event?.street_address}, ${city.name}, ${state.state_code}`}</Typography>
            <Typography>
              <span>Digital marketing:</span>
              <CheckIcon checked={parametersEvent?.digital_marketing} />
              {parametersEvent?.digital_marketing && seeDigitalMarketing && urlData && (
                <a href={urlData}> Download here!</a>
              )}
            </Typography>
            <Typography>
              Commercial insurance:
              <CheckIcon checked={parametersEvent?.commercial_insurance} />
            </Typography>
            {parametersEvent?.repeat_every && (
              <Typography>Repeat every {parametersEvent?.repeat_every}</Typography>
            )}
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <Typography>Event date: {formatDate(parametersEvent?.event_date)}</Typography>
            <Typography>Start hour: {formatTime(parametersEvent?.hour_start_event)}</Typography>
            <Typography>End hour: {formatTime(parametersEvent?.hour_end_event)}</Typography>
            <Typography>
              Cancellation deadline: {formatDate(parametersEvent?.cancellation_deadline)}
            </Typography>
            <Typography>
              Application deadline: {formatDate(parametersEvent?.application_deadline)}
            </Typography>
            {parametersEvent?.refund_deadline && (
              <Typography>
                Refund deadline: {formatDate(parametersEvent?.refund_deadline)}{' '}
                {parametersEvent?.hour_refund_deadline}
              </Typography>
            )}
          </div>
        </Grid>
      </Grid>

      <Grid container justifyContent="space-between" marginTop={2}>
        <Grid item>
          <Typography variant="h7" marginTop={0}>
            This venue includes:
          </Typography>
        </Grid>
        <Grid item sm={6}>
          <Grid container justifyContent="flex-start">
            {freeFeatures.map((item) => (
              <Grid item key={item.id}>
                <img style={{ marginRight: 10, width: 30 }} src={item.Icon} alt={item.name} />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item>
          <Typography variant="h7" marginTop={0} color="#0997BA">
            Learn more
          </Typography>
        </Grid>
      </Grid>
    </SimpleCard>
  );
}

AboutYourEvent.propTypes = {
  registeredAttendees: PropTypes.number,
  vendors: PropTypes.number,
  foodTrucks: PropTypes.number,
  event: PropTypes.instanceOf(Object).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  freeFeatures: PropTypes.any.isRequired,
  seeDigitalMarketing: PropTypes.bool,
};

AboutYourEvent.defaultProps = {
  registeredAttendees: 1,
  vendors: 1,
  foodTrucks: 1,
  seeDigitalMarketing: false,
};
